export function countTimer({ timerId, period }) {
  function declensionNum(num, words) {
    return words[
      num % 100 > 4 && num % 100 < 20
        ? 2
        : [2, 0, 1, 1, 1, 2][num % 10 < 5 ? num % 10 : 5]
    ];
  }

  const timer = ref([
    { number: "00", text: null, dots: true },
    { number: "00", text: null, dots: true },
    { number: "00", text: null, dots: true },
    { number: "00", text: null, dots: false },
  ]);

  const wordsDeclension = [
    ["@day", "@day second declension", "@days"],
    ["@hour", "@second declination of the hour", "@Hours"],
    ["@minute", "@minutes", "@second declension minutes"],
    ["@second", "@seconds", "@second declension seconds"],
  ];

  if (period.endAt) {
    const diff = period.endAt * 1000 - new Date();

    if (diff <= 0) {
      clearInterval(timerId.value);
    } else {
      const timerNumbers = [
        Math.floor(diff / 1000 / 60 / 60 / 24),
        Math.floor(diff / 1000 / 60 / 60) % 24,
        Math.floor(diff / 1000 / 60) % 60,
        Math.floor(diff / 1000) % 60,
      ];

      timer.value.forEach((el, index) => {
        el.number = timerNumbers[index];
        el.text = declensionNum(el.number, wordsDeclension[index]);
      });
    }
  }
  return { timer, timerId };
}
